import React, {useReducer, useState, useEffect, useCallback} from 'react';
import {Header} from './widgets/Header';
import {Page} from './widgets/Page';
import {Notification} from './widgets/Notification';
import {Modal} from './widgets/Modal';
import {LANG} from './Constants';
import './App.css';

export const AppContext = React.createContext(null);

let autoincrement = 1;
let langCache = {};

function notificationReducer(arr, opts)
{
	if(opts.hasOwnProperty('id'))
	{
		return arr.filter((v) => v.id !== opts.id);
	}
	const newItem = {
		id: autoincrement++,
		com: opts.elm,
		clazz: opts.clazz
	};
	return [...arr, newItem];
}

function getLang()
{
	let uri = window.location.pathname;
	let m;
	if((m = uri.match(/^\/(en|zh)(\/.*)?$/i)))
	{
		return (m[1] === 'zh' || m[1] === 'cn') ? 'cn' : 'en';
	}
	else
	{
		let lang = window.localStorage.getItem('lang');
		if(lang)
		{
			return lang === 'cn' ? 'cn' : 'en';
		}

		lang = navigator.language || navigator.userLanguage;
		return lang === 'zh-CN' ? 'cn' : 'en';
	}
}

function fixLangUrl(v)
{
	let uri = window.location.pathname;
	if(/^\/(en|zh)(\/.*)?$/i.test(uri))
	{
		let v2 = v === 'cn' ? 'zh' : v;
		let uri2 = uri.replace(/^\/(en|zh)/i, '/' + v2);
		if(uri !== uri2)
		{
			let s = window.history.state;
			/*
			if(s)
			{
				s = Object.assign({}, s);
			}
			*/
			window.history.replaceState(s, '', uri2);
		}
		return true;
	}
	return false;
}

function App()
{
	const [notifications, pushNotification] = useReducer(notificationReducer, []);
	const [modalContent, setModalContent] = useState(null);
	const [lang, setLangInternal] = useState(getLang());
	const [, updateState] = useState();
	const forceUpdate = useCallback(() => updateState({}), []);
	const setLang = useCallback((v) =>
	{
		if(!fixLangUrl(v))
		{
			window.localStorage.setItem('lang', v);
		}
		setLangInternal(v);

	}, []);


	useEffect(() =>
	{
		if(lang !== 'en')
		{
			if(langCache.hasOwnProperty(lang))
			{
				window['LANG'] = Object.assign({}, LANG, langCache[lang]);
				forceUpdate();
			}
			else
			{
				fetch(process.env.PUBLIC_URL + '/zh-CN.js').then((resp) =>
				{
					return resp.json();
				})
				.then((json) =>
				{
					langCache[lang] = json;
					window['LANG'] = Object.assign({}, LANG, json);
					forceUpdate();

				});
			}
		}
		else
		{
			delete window['LANG'];
			forceUpdate();
		}

		let onPopState = () =>
		{
			fixLangUrl(lang);
		}
		window.addEventListener('popstate', onPopState);

		return () =>
		{
			window.removeEventListener('popstate', onPopState);
		}

	}, [lang, forceUpdate]);

	return (
		<AppContext.Provider value={{lang, setLang, pushNotification, setModalContent}}>
			<Header />
			<div id="main" className={"lang-" + lang}>
				<Page />
				<Modal active={modalContent !== null} onClose={modalContent?.onClose}>{modalContent?.content}</Modal>
				<div id="notification-area">
					{
						notifications.map((n, i) =>
						{
							return <Notification key={n.id} active={true} clazz={n.clazz} id={n.id} dismiss={pushNotification}>{n.com}</Notification>;
						})
					}
				</div>
			</div>
		</AppContext.Provider>
	);
}

export default App;
